import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import MergeLeadForm from "@/modules/lead-page/components/lead-info/lead-actions/merge-lead/modals/merge-lead-modal";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { GetLeadResponse } from "@/modules/leads/dtos";
import { queryClient } from "@/queryClient";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import { Box, Typography } from "@mui/material";
import { useContext, useState } from "react";
import CommonModal from "@/modules/common/components/ui-kit/modals/common-modal";
import MobileModal from "@/modules/common/components/ui-kit/modals/mobile-modal";

const MergeLeads = ({
  mergeLeadModalOpen,
  setMergeLeadModalOpen,
}: {
  mergeLeadModalOpen: boolean;
  setMergeLeadModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { lead } = useContext(LeadPageContext);
  const screen = useScreenSize();
  const [disabledConfirmButton, setDisabledConfirmButton] = useState(true);
  const [openConfirmMergeModal, setOpenConfirmMergeModal] = useState(false);
  const [submitMergeLead, setSubmitMergeLead] = useState(false);
  return (
    <>
      <Box
        sx={{
          display: "flex",
          gap: nawyTheme.nawy.spacing.xs,
          padding: nawyTheme.nawy.spacing.xs,
          alignItems: "center",
          width: "100%",
          height: "100%",
          cursor: "pointer",
          ":hover": {
            backgroundColor: nawyTheme.nawy.colors.semantic.layer.secondary,
          },
        }}
        onClick={() => setMergeLeadModalOpen(true)}
      >
        <Typography
          sx={{
            color: nawyTheme.nawy.colors.semantic.text.primary,
            ...nawyTheme.nawy.typography.english.variants.body.md.regular,
          }}
          variant="h5_bold"
        >
          Merge Leads
        </Typography>
      </Box>

      {screen.isMobile ? (
        <MobileModal
          open={mergeLeadModalOpen}
          onClose={() => {
            setMergeLeadModalOpen(false);
            queryClient.removeQueries(["getChildLead"]);
          }}
          title="Merge leads"
          confirmButtonText="Merge"
          cancelButtonText="Cancel"
          onConfirm={() => setOpenConfirmMergeModal(true)}
          isConfirmDisabled={disabledConfirmButton}
          snapPoints={[1]}
        >
          <Box
            sx={{
              height: "100%",
              width: "100%",
              display: "flex",
              overflowY: "auto",
              flexDirection: "column",
              padding: nawyTheme.nawy.spacing.xxxs,
              borderRadius: nawyTheme.nawy.radius["2xl"],
            }}
          >
            <MergeLeadForm
              currentParentLead={lead}
              setDisabledConfirmButton={setDisabledConfirmButton}
              setSubmitMergeLead={setSubmitMergeLead}
              submitMergeLead={submitMergeLead}
              openConfirmMergeModal={openConfirmMergeModal}
              setOpenConfirmMergeModal={setOpenConfirmMergeModal}
              setMergeLeadModalOpen={setMergeLeadModalOpen}
            />
          </Box>
        </MobileModal>
      ) : (
        <CommonModal
          open={mergeLeadModalOpen}
          onClose={() => {
            setMergeLeadModalOpen(false);
            queryClient.removeQueries(["getChildLead"]);
          }}
          title="Merge Leads"
          cancelButtonText="Cancel"
          confirmButtonText="Merge Leads"
          onConfirm={() => setOpenConfirmMergeModal(true)}
          isLoading={false}
          isConfirmDisabled={disabledConfirmButton}
          sx={{ width: "600px", maxHeight: "750px" }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              width: "100%",
              overflowY: "auto",
              borderRadius: nawyTheme.nawy.radius["2xl"],
              padding: nawyTheme.nawy.spacing.md,
            }}
          >
            <MergeLeadForm
              currentParentLead={lead as GetLeadResponse | undefined}
              setDisabledConfirmButton={setDisabledConfirmButton}
              setSubmitMergeLead={setSubmitMergeLead}
              submitMergeLead={submitMergeLead}
              openConfirmMergeModal={openConfirmMergeModal}
              setOpenConfirmMergeModal={setOpenConfirmMergeModal}
              setMergeLeadModalOpen={setMergeLeadModalOpen}
            />
          </Box>
        </CommonModal>
      )}
    </>
  );
};

export default MergeLeads;
